<template>
  <v-flex xs12 pt-1 pb-0>

    <div>
    <v-chip
       v-for="activeFlag in directorFlags"
       v-bind:key="activeFlag"
       @input="removeActiveFlag(activeFlag.id)"
       small
       close
    >
       <v-avatar v-if="activeFlag.enabled" class="green"><v-icon>mdi-thumb-up</v-icon></v-avatar>
       <v-avatar v-if="!activeFlag.enabled" class="red"><v-icon>mdi-thumb-down</v-icon></v-avatar>
       {{ flagNameById(activeFlag.id) }}
    </v-chip>
    </div>

    <v-dialog v-model="newDirectorFlagDialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn small color="accent" class="mr-3" v-on="on">
        <v-icon>mdi-plus</v-icon> {{ $t('app.newDirectorFlag') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline lighten-2" primary-title>
        {{ $t('app.addNewDirectorFlag') }}
      </v-card-title>
      <v-card-text>
        {{ $t('design.directorFlagsLongText') }}
        <v-select
          :label="$t('app.addNewDirectorFlag')"
          :items="allDirectorFlags"
          item-text="name"
          item-value="id"
          v-model="newDirectorFlagId"
        ></v-select>
        <v-switch
            :label="$t('design.directorDepressed')"
            v-model="newDirectorFlagActive">
        </v-switch>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="(typeof(newDirectorFlagId) === 'undefined') || (newDirectorFlagId == '')"
          @click="addActiveFlag();newDirectorFlagDialog = false"
        >{{ $t('general.apply') }}</v-btn>
        <v-btn @click="newDirectorFlagDialog = false">{{ $t('general.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

  </v-flex>
</template>
<script>
import axios from 'axios';

export default {
  props: ['directorFlags'],
  data() {
    return {
      widgetId: false,
      newDirectorFlagDialog: false,
      allDirectorFlags: [],
      // allDirectorFlags: [{ id: 2, name: 'asd' }, { id: 3, name: 'cb' }],

      newDirectorFlagId: '',
      newDirectorFlagActive: true,
    };
  },
  mounted() {
    this.getAllDirectorFlags();
  },
  methods: {
    getAllDirectorFlags() {
      const vm = this;
      axios.get(`${window.api_url}api/director-flags`, {
        params: {
          paginate: false,
        },
      })
        .then((response) => {
          vm.allDirectorFlags = response.data.data;
        });
    },
    flagNameById(id) {
      let retval = '';
      this.allDirectorFlags.forEach((item, index) => { // eslint-disable-line no-unused-vars
        if (item.id === id) retval = item.name;
      });
      return retval;
    },
    removeActiveFlag(id) {
      const newDirectorFlags = this.directorFlags.filter((obj) => obj.id !== id);
      try {
        // the following line generates a warning, but I don't care.
        this.directorFlags = newDirectorFlags;
      } catch (err) {
        // ignore
      }
      this.$emit('update:directorFlags', newDirectorFlags);
    },
    addActiveFlag() {
      if (this.newDirectorFlagId === '') return;
      if (typeof (this.directorFlags) === 'undefined') {
        this.directorFlags = [];
      }
      // eslint-disable-next-line max-len
      const newDirectorFlags = this.directorFlags.filter((obj) => obj.id !== this.newDirectorFlagId);
      newDirectorFlags.push({
        id: this.newDirectorFlagId,
        enabled: this.newDirectorFlagActive,
      });
      try {
        // the following line generates a warning, but I don't care.
        this.directorFlags = newDirectorFlags;
      } catch (err) {
        // ignore
      }
      this.$emit('update:directorFlags', newDirectorFlags);
    },
  },
};

</script>
